import { Component, OnInit } from "@angular/core";
import { EdpSelectList } from "@edp-models/edp-select-list";
import { Language } from "@edp-models/language.model";
import { LanguageService } from "@edp-services/language.service";
import { GetLanguages } from "@edp-store/actions/language.actions";
import { getLanguages } from "@edp-store/selectors/language.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";

@Component({
    selector: "edp-overlay-user-language",
    templateUrl: "./edp-overlay-user-language.component.html",
    styleUrls: ["./edp-overlay-user-language.component.scss"],
})
export class EdpOverlayUserLanguageComponent implements OnInit {
    languages: Array<EdpSelectList> = [];
    selected: string;

    public constructor(private readonly store: Store<IAppState>, private readonly languageService: LanguageService) {}

    public ngOnInit(): void {
        this.selected = this.languageService.getUserLanguage();
        this.store.pipe(select(getLanguages)).subscribe((data: Language[]) => {
            if (!!data && !!data.length) {
                this.languages = data.map(i => {
                    return {
                        text: i.language_slug,
                        value: i.language_key,
                        selected: this.selected === i.language_key,
                    };
                });
            } else {
                this.store.dispatch(new GetLanguages());
            }
        });
    }

    public onSelectListChange(value: EdpSelectList): void {
        this.languageService.setUserLanguage(value.value);
    }

    public onOpen(value: boolean): void {
        if (value) {
            this.languageService.sendOperationHistoryService("Click_toogle_language", "");
        }
    }
}
